import React from 'react';
import './AndroidInstallPrompt.css';

const AndroidInstallPrompt = ({ onClose }) => {
  return (
    <div className="android-install-overlay" onClick={onClose}>
      <div className="android-install-modal" onClick={(e) => e.stopPropagation()}>
        <button className="android-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="android-modal-content">
          <div className="android-modal-header">
            <h2>Install on Android</h2>
            <p className="android-modal-subtitle">Add Vardaan Global to your home screen</p>
          </div>

          <div className="android-install-steps">
            <div className="android-step">
              <div className="android-step-number">1</div>
              <div className="android-step-content">
                <h3>Open Chrome menu</h3>
                <p>Tap the <strong>⋮</strong> menu in the top-right corner</p>
              </div>
            </div>

            <div className="android-step">
              <div className="android-step-number">2</div>
              <div className="android-step-content">
                <h3>Select Install app</h3>
                <p>Choose <strong>Install app</strong> or <strong>Add to Home screen</strong></p>
              </div>
            </div>

            <div className="android-step">
              <div className="android-step-number">3</div>
              <div className="android-step-content">
                <h3>Confirm install</h3>
                <p>Tap <strong>Install</strong> and the app icon will appear on your home screen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AndroidInstallPrompt;
